(function() {
	/*
	 * Participant Summary
	 * Requires the following libs:
	 * profilePicService.js
     * ui-bootstrap
     *
     * Attributes:
     *  @participants - Object required; containing participant data, one-way binding
     *  @totalParticipants - Integer, required; The total number of participants. Used with the "+More" link.
     *  @modalInfo -
     *  @commentLength - Object required; An object with keys for each media size. Each size as a number of characters at which to truncate the comment to maintain 2 line max. Now includes "with ads" alternatives.
     *  @showNames - Boolean required; True/False indicating to show participant names or not
     *  @showProfilePics - Boolean required; True/False indicating to show profile pics or not
     *  @hasAds - Boolean required; True/False indicating if the sign up has Ads or not. Used for size adjustments.
     *  @segmentsConfig - Object required; A reference to the main objConfig variable which holds the Segements (Ads) configuration.
     *  @isSignupCloseLocked -
     *  @isModifyLocked - Boolean required; whether or not modifying the slotitem is locked
     *  @memberId - Integer optional; currently loggedin user's member id
     *  @columnCount - Integer optional; The number of columns displayed in the sign up table. Defaults to 1.
     *  @themeStyles - Object required; the css style rules
     *  @onEdit - Function, required; function to execute when the edit button is clicked (will pass in participant's itemmemberid, slotitemid, & memberid)
     *  @onSwap - Function, required; function to execute when the swap button is clicked (will pass in participant's itemmemberid, slotitemid, & memberid)
     *  @onDelete - Function, required; function to execute when the delete button is clicked (will pass in participant's itemmemberid, slotitemid, & memberid)
     *  @onOpenDetails - Function, required; function to execute when the +x more link is clicked
     *
     * Usage: <participant-summary
     *           participants="i.participants"
     *           total-participants="i.participantcount"
     *           modal-info="i.deleteModalInfo"
     *           comment-length="{lg:160, md:110, sm:100, adslg:80, adsmd:80, adssm:80}"
     *           show-names="isUserSignUpOwner || isUserSignUpAdmin || (signupInfo.shownames && !i.donotshow)"
     *           show-profile-pics="signupInfo.showprofilepics"
     *           has-ads="showads" is-modify-locked="i.ismodifylocked"
     *           segments-config="objConfig"
     *           is-signup-close-locked="isLocked() && signupInfo.closelock"
     *           member-id="memberId"
     *           column-count="columnCount"
     *           theme-styles="{'background-color':theme.buttoncolor, 'color':theme.buttontextcolor}"
     *           on-open-details="openParticipantDetails(signupInfo.id,memberId,f,i)"
     *           on-edit="editItemMember" on-delete="deleteItemMember"
     *           on-swap="swapItemMember">
     * </participant-summary>
	 */
	SUGApp.directive('participantSummary', ['$window','profilePicService', function ($window, profilePicService) {
		return {
			restrict: 'E',
			templateUrl: '/view/templates/ngtemplates/participant-summary.html',
			scope: {
                participants: '<',
                totalParticipants: '<',
                modalInfo: '<',
                commentLength: '<',
                showNames: '<',
                showProfilePics: '<',
                hasAds: '<',
                segmentsConfig: '<',
                isSignupCloseLocked: '<',
                isModifyLocked: '<',
                memberId: '@?',
                columnCount: '<',
                themeStyles: '<',
                onEdit: '&',
                onSwap: '&',
                onDelete: '&',
                onOpenDetails: '&'
			},
			link: function(scope, element, attrs) {

                /* Tooltip vars */
                scope.pop = {
                    trig: 'mouseenter',
                    placement: 'top',
                    delay: 300
                };

                // static strings
                scope.str = {
                    edit: 'Edit',
                    swap: 'Swap',
                    delete: 'Delete',
                    paymentpending: '[Payment Pending]',
                    locked: 'The signup creator has locked this item from being changed.'
                };

				// this runs first
				function init(){
                    unwrapHandlers();
                    // convert memberId to an integer
                    scope.memberId = Number.isInteger(parseInt(scope.memberId)) ? parseInt(scope.memberId) : 0;

                    scope.columnCount = typeof columnCount == 'undefined' ? 1 : columnCount;
				}

                /**
                 * We have to unwrap these event handlers so that we can pass in parameters
                 */
                function unwrapHandlers(){
                    scope.onEdit = scope.onEdit();
                    scope.onSwap = scope.onSwap();
                    scope.onDelete = scope.onDelete();
                }

                /**
                 * Returns the number of participants to display in the summary listing
                 */
                scope.getParticipantLimit = function(){
                    var limit = 0;
                    // if the user is logged in, ensure we show all of their signed up items and use that as the limit
                    scope.participants.forEach( function(participant){
                        if( participant.memberid == scope.memberId ){
                            limit++;
                        }
                    });

                    // ensure we set the min to five
                    return Math.max(10,limit);
                };

                /**
                 * Returns the count of participants remaining that are not displayed
                 */
                scope.getMoreParticipantsCount = function(){
                    return Math.max(0,scope.totalParticipants - scope.getParticipantLimit());
                };

                /**
                 * Determines whether to show the more participants link
                 */
                scope.showMoreParticipants = function(){
                    return scope.showNames && scope.getMoreParticipantsCount();
                };

                /**
                 * Determines if we should show the participants summary
                 */
                scope.showParticipantSummary = function(){
                    return ( scope.participants ) ? true : false;
                };

                /**
                 * Determines if we should show the specific participant using the provided memberid
                 * @mid {Integer} - the participant's member id
                 */
                scope.showParticipant = function(mid){
                    return scope.showNames || mid == scope.memberId;
                };

                /**
                 * Wrapper for the profilePicService method, this is so that we can easily add additional functionality specific to the participant summary later
                 */
                scope.parseProfilePicData = function(participant){
                    return profilePicService.parseProfilePicData(participant);
                };

                /**
                 * Return comment truncation length based on media size and ads display
                 */
                scope.getCommentLength = function(mediasize){
                    return scope.hasAds ? scope.commentLength['ads' + mediasize] : scope.commentLength[mediasize];
                };

                /**
                 * Return comment truncation length based on media size and ads display
                 */
                scope.showMoreLink = function(comment, mediasize){
                    return scope.hasAds ? comment.length > scope.commentLength['ads' + mediasize] : comment.length > scope.commentLength[mediasize];
                };

                /**
                 * Return participant first and last name as a single value so it can be trunctated as necessary
                 * @param {Object} participant - participant model that is being looped over in the display
                 */
                scope.getFullName = function(participant){
                    return participant.firstname + ' ' + participant.lastname;
                };

                /**
                 * Returns true to add an insert CSS class, if the criteria is met
                 * @param {Object} participant - participant model that is being looped over in the display
                 */
                /*
                scope.indentControls = function( participant ){

                    var nameLength = scope.getFullName(participant).toString().length;
                    var twoDigitQty = participant.myqty > 9;
                    var showSwap = participant.allowswap && (!scope.isSignupCloseLocked || !scope.isModifyLocked);
                    var showDelete = participant.allowdelete && (!scope.isSignupCloseLocked || !scope.isModifyLocked);
                    var showEdit = scope.memberId > 0 && scope.memberId == participant.memberid;

                    //4col layout
                    if(scope.columnCount == 4){
                        //LG Screen size
                        if( $window.innerWidth > 1199
                            && scope.hasAds             // 4col with ads
                            && nameLength >= 14
                            && twoDigitQty
                            && scope.memberId > 0       //possible edit pencil
                            &&  //thick side ad, with swap and delete
                                ( !scope.segmentsConfig.showthin && showSwap && showDelete)
                                ||
                                //2 thin side ads, with swap, or delete, or 2-digit qty OR just a pencil icon with a longer name
                                ( ( scope.segmentsConfig.showleft && scope.segmentsConfig.showright )
                                  && ( showSwap || showDelete || twoDigitQty || (nameLength >= 18 && showEdit && participant.myqty == 1) )
                                )
                        ){ return true; }

                        //MD Screen size - 4col
                        else if($window.innerWidth <= 1199)
                        {   //4col NO ADS
                            if(!scope.hasAds && nameLength >= 14 && twoDigitQty && showEdit && showSwap && showDelete )
                            { return true; }

                            // 4col WITH ADS (medium only has 1 ad config)
                            else if( scope.hasAds
                                    && (
                                        ( nameLength >= 16 && ( showEdit || twoDigitQty ) )
                                        ||
                                        ( showEdit  && ( showSwap || showDelete ) )
                                    )
                            ){ return true; }
                        }
                    }

                    // 3Col
                    else if(scope.columnCount == 3){
                        //MD Screen size - 3col
                        if($window.innerWidth <= 1199 && showEdit  && ( showSwap || showDelete )){
                            return true;
                        }
                    }

                    // 2Col
                    else if(scope.columnCount == 2){
                        //LG Screen size
                        if($window.innerWidth > 1199
                            && scope.hasAds && nameLength >= 18 && twoDigitQty && showEdit && ( showSwap || showDelete )
                        ){ return true; }

                        //MD Screen size
                        else if( $window.innerWidth <= 1199
                            && scope.hasAds && ( nameLength >= 18 || (twoDigitQty && nameLength >= 14) )
                        ){ return true; }
                    }

                    return false;
                };
                */

                // fire init
				init();
            }
        };
    }]);

}());
